// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumb_container__2lFy8","darken":"BreadCrumb_darken__3Tqgd"};